import styled from 'styled-components';
import InfoIcon from '@mui/icons-material/Info';

export const StyledInfoIcon = styled(InfoIcon)`
  color: ${({ theme }): string => theme.font};
`;